import dayjs from 'dayjs';
import moment from 'moment';
import { SERVER_DATE_FORMAT } from '../constants';
export var dayjsToMoment = function (d) {
    return moment(d.toISOString());
};
export var momentToDayjs = function (d) {
    return dayjs(d.toISOString());
};
export var isHoliday = function (d, holidays) {
    return !!holidays[d.format(SERVER_DATE_FORMAT)];
};
export var isWeekend = function (d) {
    return d.day() % 6 === 0;
};
//# sourceMappingURL=dates.js.map